import { useEffect, FC, useMemo } from 'react';
import { useIntl, defineMessages } from 'react-intl';
import { useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import Loader from '../../components/Loader/Loader';
import Content from '../../components/Content/Content';
import FormError from '../../components/FormError/FormError';
import { useAppDispatch } from '../../redux/Store';
import { RemoteStatus } from '../../redux/SharedTypes';
import OrderActions from '../../redux/OrderSlice/OrderActions';
import { fetchOrder } from '../../redux/OrderSlice/OrderThunks';
import { getOrder } from '../../redux/OrderSlice/OrderSelectors';
import OrderView from './OrderView/OrderView';
import { getErrorMessageOrDefault } from '../../helpers/errorMessageHelper/errorMessageHelper';

const messages = defineMessages({
	defaultErrorMessage: {
		id: 'payments.some_errors_occured',
		defaultMessage: 'Some errors occurred',
	},
});

const Order: FC = () => {
	const { formatMessage } = useIntl();
	const dispatch = useAppDispatch();
	const { id = '' } = useParams<{ id?: string }>();
	const { status, error } = useSelector(getOrder);

	const content = useMemo(() => {
		switch (status) {
			case RemoteStatus.InProgress:
				return <Loader />;
			case RemoteStatus.Error:
				return (
					<Content name={formatMessage(messages.defaultErrorMessage)} showBadge={false}>
						<FormError message={formatMessage(getErrorMessageOrDefault(error))} />
					</Content>
				);
			case RemoteStatus.Done:
				return <OrderView />;
			default:
				return null;
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [status]);

	useEffect(() => {
		if (status === RemoteStatus.None) dispatch(fetchOrder(id));
	}, [dispatch, id, status]);

	useEffect(() => {
		return () => {
			dispatch(OrderActions.reset());
		};
	}, [dispatch]);

	return content;
};

export default Order;
